export default __webpack_public_path__ + "static/media/vellumcourt_2048_1536.6b0e76f7.jpg";